import { Injectable } from '@angular/core';
import { AngularFireAuth } from "angularfire2/auth";
import { AngularFireDatabase } from 'angularfire2/database';
import { Subject } from 'rxjs/Subject';
import { Ng2ImgToolsService } from 'ng2-img-tools';

@Injectable()
export class Shared {

  current_user; //USER FROM afAuth.auth.signInWithEmailAndPassword
  firebase_user; //USER FROM FIREBASE DATABASE
  guard_sub = false;
  product_query = new Subject();
  tab = 'everything';
  control_tab = 'print';

  // NEEDED FOR PRODUCT-FORM

  cannabinoids = [];
  categories = [];
  chem_measurements = [];
  qualities = [];
  species = [];
  symptoms = [];
  terpenes = [];
  weights = [];
  settings;
  products;
  locations;

  userRef;
  userObservable;

  productsRef;
  productsObservable;

  settingsRef;
  settingsObservable;

  locationsRef;
  locationsObservable;

  userLocationRef;
  userLocationObservable;

  salesRef;
  salesObservable;

  UsersRef;
  UsersObservable;


  userLocation;
  globalSale;
  noGlobalSale = true;
  sales;
  switchActive = false;
  popup = false;
  mobile_menu = false;
  settings_tabs = false;

  SET = false;
  last_desc;
  recatSet = false;
  subbed = false;

  constructor(public afAuth: AngularFireAuth, private db: AngularFireDatabase, private imageTools: Ng2ImgToolsService) {
  }

  setControlTab(tab){
      this.control_tab = tab;
  }

  setTab(tab){
      this.last_desc = this.tab;
      this.tab = tab;
  }

  toggleMenu(){
      this.mobile_menu = !this.mobile_menu;
      if(this.switchActive){
        this.switchActive = false;
      }
  }

  preprocessImages(images){
    return this.imageTools.resizeExactCrop(images, 550, 550).flatMap(images => this.imageTools.compress(images, .25));
  }

  getInfo(){

    this['colors'] = [...Array.from(Array(41).keys())];

     this.userRef = this.db.object(`/${this.current_user.uid}`);
     this.userObservable = this.userRef.snapshotChanges().map(action => {
       const $key = action.payload.key;
       const data = {$key, ...action.payload.val()};
       return data;
     });
     this.userObservable.subscribe(user => {

         //console.log("USER: ", user);
         this.firebase_user = user;

         this.locationsRef = this.db.list(`/${this.firebase_user.brewery}/locations`);
         this.locationsObservable = this.locationsRef.snapshotChanges().map(action => {
           return action.map(item => {
             const $key = item.payload.key;
             const data = {$key, ...item.payload.val()};
             return data;
           });
         })
         this.locationsObservable.subscribe(locations => { //LOCATIONS LIST
             //console.log("LOCATIONS: ",locations);
             this.locations = locations;
         });

         this.productsRef = this.db.list(`/${this.firebase_user.brewery}/products`);
         console.log(this.productsRef);
         this.productsObservable = this.productsRef.snapshotChanges().map(action => {
           return action.map(item => {
             const $key = item.payload.key;
             const data = {$key, ...item.payload.val()};
             return data;
           });
         })
         console.log(this.productsObservable);
         this.productsObservable.subscribe(products => { //PRODUCTS LIST Ref
             console.log("PRODUCTS: ",products);
             //console.log(this.products_list);
             this.products = products;
             if(!this.SET){
                 products.map(product => {
                     this.SET = true;
                     this.productsRef.update(product.$key, {'everything':true});
                 });
                 this.product_query.next('everything');
                 this.last_desc = 'everything';
             }
             if(this.tab != this.last_desc){
                 this.product_query.next(this.tab);
                 this.last_desc = this.tab;
             }
         });

         this.product_query.next("everything");

         this.settingsRef = this.db.object(`/${this.firebase_user.brewery}/settings`);
         this.settingsObservable = this.settingsRef.snapshotChanges().map(action => {
           const $key = action.payload.key;
           const data = {$key, ...action.payload.val()};
           return data;
         });
         this.settingsObservable.subscribe(settings =>{ //SETTINGS OBJECT Ref
             //console.log("SETTINGS: ",settings)
             this.settings = settings;
         });

         this.userLocationRef = this.db.object(`/${this.firebase_user.brewery}/locations/${this.firebase_user.location}`);
         this.userLocationObservable = this.userLocationRef.snapshotChanges().map(action => {
           const $key = action.payload.key;
           const data = {$key, ...action.payload.val()};
           return data;
         });
         this.userLocationObservable.subscribe(userLocation => {
             //console.log("USERLOCATION: ",userLocation);
             this.userLocation = userLocation;
         });

         this.salesRef = this.db.list(`/${this.firebase_user.brewery}/locations/${this.firebase_user.location}/sales`);
         this.salesObservable = this.salesRef.snapshotChanges().map(action => {
           return action.map(item => {
             const $key = item.payload.key;
             const data = {$key, ...item.payload.val()};
             return data;
           });
         });
         this.salesObservable.subscribe(sales_list => {
             //console.log("SALES_LIST: ",sales_list);
             let arr = sales_list.filter(obj => {return obj.active});
             //console.log(arr);
             this.sales = sales_list;
             if(arr.length){
                 this.globalSale = arr[0];
                 this.noGlobalSale = false;
             } else {
                 this.noGlobalSale = true;
             }
         });

         if(user.role === 'admin'){

             this.UsersRef = this.db.list('/', ref =>  ref.orderByChild("brewery").equalTo(user.brewery));
             this.UsersObservable = this.UsersRef.snapshotChanges().map(list => {
                return list.filter(item => { return item.payload.val()['role']}).map(item => {
                  const $key = item.payload.key;
                  const data = {$key, ...item.payload.val()};
                  return data;
                });
             });
             //this.UsersObservable.subscribe(users => console.log("USERS: ",users));

         }

     });
     this.db.object('/global-info').snapshotChanges().map(action => action.payload.val()).subscribe(global_info => {
       Object.keys(global_info).map(value => {
         this[value] = [];
         Object.keys(global_info[value]).map( nested_value => {
           this[value].push({key:nested_value, value:global_info[value][nested_value]});
           });
         //console.log(this[value]);
         });
      });
      //this.setTab('a');
  };

  isNullOrUndefined(tester){
      return (tester === null || tester === undefined);
    }

  getBoardlink(uuid){
    //console.log(uuid);
      return this.db.object(`/${uuid}`);
  }

  reCategorizeAll(){
      this.recatSet = false;
      //console.log('\n\n\nPRE IF\n\n\n');
      if(this.subbed != true){
          //console.log('\n\n\nPRE SUB\n\n\n');
          this.productsObservable.subscribe(list => {
              this.subbed = true;
              //console.log('\n\n\nSUBBED\n\n\n');
              if(!this.recatSet){
                  this.recatSet = true;
                  //console.log('\n\n\nPREMAP\n\n\n');
                  list.map(product => {
                      //console.log('MAP');
                      this.productsObservable.update(product.$key, this.categorize(product, this.tab));
                  });
              }
          });
      }
  }

  categorize(product, category){
      // SET [CANNABIS, CONCENTRATE, EDIBLE]
      switch(category){
          case 'a':
              product['a'] = true;
              product['b'] = false;
              product['c'] = false;
              break;
          case 'b':
              product['a'] = false;
              product['b'] = true;
              product['c'] = false;
              break;
          case 'c':
              product['a'] = false;
              product['b'] = false;
              product['c'] = true;
              break;
      }

      // SET HIGH_THC AND HIGH_CBD
      Object.keys(product.cannabinoids).map(key => { return product.cannabinoids[key] }).map(cannabinoid => {
          if((cannabinoid.cannabinoid === 'THC' || cannabinoid.cannabinoid === 'CBD') && cannabinoid.measurement === '%' ){
              switch(cannabinoid.cannabinoid){
                  case 'THC': //TODO: Make parse string to float
                      if(parseFloat(cannabinoid.amount) >= parseFloat(this.settings.high_thc)){
                          product['d'] = true;
                          break;
                      }
                      product['d'] = false;
                      break;
                  case 'CBD':
                      if(parseFloat(cannabinoid.amount) >= parseFloat(this.settings.high_cbd)){
                          product['e'] = true;
                          break;
                      }
                      product['e'] = false;
                      break;
              }
          };
      });

      let type: String = product.type;
      //SET SATIVA TO INDICA
      switch(product.type){
          case 'sativa':
              product['f'] = true; product['g'] = true; product['h'] = false; product['i'] = false; product['j'] = false;
              break;
          case 'h-sativa-dom':
              product['f'] = false; product['g'] = true; product['h'] = true; product['i'] = false; product['j'] = false;
              break;
          case 'hybrid':
              product['f'] = false; product['g'] = false; product['h'] = true; product['i'] = false; product['j'] = false;
              break;
          case 'h-indica-dom':
              product['f'] = false; product['g'] = false; product['h'] = true; product['i'] = true; product['j'] = false;
              break;
          case 'indica':
              product['f'] = false; product['g'] = false; product['h'] = false; product['i'] = true; product['j'] = true;
              break;
          default:
              product['f'] = false; product['g'] = false; product['h'] = false; product['i'] = false; product['j'] = false;
              break;
      }
      // MAKE SURE IT SHOWS UP IN EVERYTHING

      product['everything'] = true;

      return product;
  }

  getCannabinoids(product){
      return Object.keys(product.cannabinoids).map(key => { return product.cannabinoids[key] });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared.service.ts